import { BroadcastChannel } from 'broadcast-channel';

type HPInvalidationMessage = { type: 'invalidate' };

/**
 * Broadcast channel for cross-window HP invalidation.
 * After save/delete on viewer/0, posts a message so viewer/1 can refetch.
 */
const hpInvalidationChannel = new BroadcastChannel<HPInvalidationMessage>('hp-invalidation');

export const broadcastHPInvalidation = (): void => {
  hpInvalidationChannel.postMessage({ type: 'invalidate' });
};

/** Exposed for useHangingProtocol to listen for invalidation events. */
export { hpInvalidationChannel };
